import { fireLinkTag } from '~/features/analytics/tagManager';
import { useWnm } from '~/modules/worry-no-more/composables/useWnm';

export function useProtectionPlanAnalytics() {
  const { protectionPlans } = useWnm();

  return {
    getExtraData: (): Record<string, string[]> => (protectionPlans.value?.length ? { protection_plan_eligible: ['true'] } : {}),
  };
}

export function fireDrawerOpenTag() {
  fireLinkTag({
    event_name: 'add protection plan start',
    site_action: 'add protection plan start',
    action_location: 'product',
  });
}

export function firePlanSaveTag(planName: string) {
  fireLinkTag({
    event_name: 'add protection plan complete',
    site_action: 'add protection plan complete',
    action_location: 'product',
    action_misc: planName,
  });
}
